<template>
  <v-card class="m-4">
    <v-tabs
      background-color="warning accent-4"
      center-active
      dark
      v-model="selectedTab"
    >
    <v-tab>
      {{ formated_date(get_plan.date) }}
     </v-tab>
      <v-tab>
        <v-btn text color="white" dark @click="$router.push('/plans') ">
              Календарь
        </v-btn>
      </v-tab>
      <!-- <v-tab>
        <v-dialog v-model="dialog" persistent width="30vw">
          
          <template v-slot:activator="{ on, attrs }">
            <v-btn text color="white" dark v-bind="attrs" v-on="on">
              Добавить
            </v-btn>
          </template>
          
          <v-card>
            <v-card-title>
              <span class="headline">Укажите дату</span>
            </v-card-title>

            <v-card-text>
              <input type="date" v-model="new_date" class="h6" />
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false"
                >Закрыть</v-btn
              >
              <v-btn color="warning" dark @click="save()">Создать</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-tab> -->
    </v-tabs>
      
    <template v-if="get_plan">
      <v-card-text>
        <v-container fluid>
          <div class="groups-grid">
            <Group
              v-for="group in get_plan.groups"
              :key="group._id"
              :group="group"
              :plan="true"
              :small="true"
              :status="get_plan.status"
            />
          </div>
        </v-container>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Group from "@/components/Group.vue";

export default {
  name: "PlansList",
  data: () => ({
    dialog: false,
    new_date: null,
    statistic: null,
    selectedTab: null,
    date: new Date(),
  }),
  components: {
    Group,
  },
  computed: {
    ...mapGetters(["get_plan", "get_statistic_by_id"]),
  },
  created() {
    this.load_plan({date: this.$route.params.date});

    if (!this.get_plan.length)
      setTimeout(() => {
        this.get_id();
      }, 400);
    else this.get_id();
  },

  methods: {
    ...mapActions(["load_plan", "create_plan"]),
    get_id() {
      // this.set_plan_id(this.get_plan._id);
    },
    formated_date(date) {
      return new Date(date).toLocaleDateString("ru-RU");
    },
    set_plan_id(_id) {
      return (this.statistic = this.get_statistic_by_id(_id));
    },
    save() {
      if (!this.new_date) return false;

      this.create_plan({ date: this.new_date })
        .then((res) => {
          console.log(res);
          this.dialog = false;
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    check(stats) {
      stats.forEach((stat, index) => {
        if (
          stat.date ==
          this.date
            .toLocaleDateString("ru-RU")
            .replace(/\./g, "-")
            .split("-")
            .reverse()
            .join("-")
        ) {
          this.selectedTab = index;
        }
      });

      return stats;
    },
  },
};
</script>